export function getCurrentPath(wixCodeApi) {
  var _wixCodeApi$site$curr;
  const paths = wixCodeApi.location.path;
  if ((_wixCodeApi$site$curr = wixCodeApi.site.currentPage) != null && _wixCodeApi$site$curr.prefix) {
    return [wixCodeApi.site.currentPage.prefix, ...paths];
  }
  return paths;
}
//# sourceMappingURL=getCurrentPath.js.map